import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://fxlorumfwzrdwiftbalo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ4bG9ydW1md3pyZHdpZnRiYWxvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA2ODAwNTEsImV4cCI6MjA2NjI1NjA1MX0.m44iLQyyKRItprtThnoWjuhsG9ePi_HdBmGLlSiPNoQ";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});